import { render } from "./Shengxiao.vue?vue&type=template&id=4e2f6587&scoped=true"
import script from "./Shengxiao.vue?vue&type=script&lang=js"
export * from "./Shengxiao.vue?vue&type=script&lang=js"

import "./Shengxiao.vue?vue&type=style&index=0&id=4e2f6587&scoped=true&lang=css"

import exportComponent from "/Users/windy/work/vue/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2f6587"]])

export default __exports__